/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const DashboardTypes = {
  GET_DASHBOARD: asyncActionType('GET_DASHBOARD'),
  GET_DASHBOARD_SUPPLIER_DOCUMENT: asyncActionType('GET_DASHBOARD_SUPPLIER_DOCUMENT'),
  GET_DASHBOARD_AUDIT_CERTIFICATION: asyncActionType('GET_DASHBOARD_AUDIT_CERTIFICATION'),
  GET_DASHBOARD_PRODUCT_CERTIFICATION: asyncActionType('GET_DASHBOARD_PRODUCT_CERTIFICATION'),
  GET_DASHBOARD_PRODUCT_TESTING: asyncActionType('GET_DASHBOARD_PRODUCT_TESTING'),
  UPLOAD_BR_FILE: asyncActionType('UPLOAD_BR_FILE'),
  GET_EXPIRING_REPORTS: asyncActionType('GET_EXPIRING_REPORTS'),
  DISMISS_REMINDER_REPORT: asyncActionType('DISMISS_REMINDER_REPORT'),
};
